export const isValidNumber = (value: number | undefined | null) => value !== undefined && value !== null;

const getNavigatorLanguage = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  } else {
    return navigator.language || 'en-US';
  }
};

/**
 * Formats a given amount as a currency string, rounding up to the nearest
 * specified fraction digit.
 *
 * @param amount - The numeric value to be formatted.
 * @param currency - The currency code (e.g., 'USD', 'EUR') to format the amount in.
 * @param locale - The locale string (e.g., 'en-US', 'de-DE') to format the currency.
 * @param fractionDigits - The number of decimal places to include in the formatted string. Defaults to 2.
 * @returns A string representing the formatted currency value.
 */
export const formatCurrency = (
  amount?: number,
  currency?: string,
  locale = getNavigatorLanguage(),
  fractionDigits = 2,
): string => {
  if (!(isValidNumber(amount) && currency)) return '';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount as number);
};

export const formatCents = (currency: string) => (cents: number) => {
  const locale = navigator.language;
  return new Intl.NumberFormat(locale || 'en-US', {
    style: 'currency',
    currency,
  }).format(cents / 100);
};
